import {BaseCachedService} from "./Core/BaseCachedService";
import {BaseService} from "./Core/BaseService";
import {FileUtils} from "../Utils";

class QueryToolService extends BaseCachedService {
    get Url() { return super.Url + "/queryTool"; }

    QueryData(query, withCount, download = false) {
        return this.SendRequest(BaseCachedService.POST, {query, withCount, download});
    }

    async DownloadFile(fileName, query) {
        this.SetLoading();
        
        try {
            await FileUtils.SaveFileDownload(
                fetch(this.Url, {
                    method: 'POST',
                    headers: { 'Authorization': BaseService.AUTH_TOKEN },
                    body: JSON.stringify({
                        query: { ...query, fileName },
                        withCount: false,
                        download: true
                    })
                })
            );
        } catch (error) {
            alert(error);
        } finally {
            this.SetLoading(false);
        }
    }
}

export const service = new QueryToolService();

